<!--
 * @Author: vince
 * @Date: 2021-08-16 09:32:29
 * @LastEditors: vince
 * @LastEditTime: 2021-09-07 15:56:54
 * @Description:
-->
<template>
  <div class="teaching-design" v-loading="pageLoading">
    <el-form class="full-width" :model="filterFrom">
      <div class="filter-bar mb-sm" type="flex">
        <el-form-item class="mb-none" label="类型">
          <dic-selector
            dicType="radiationType"
            v-model="filterFrom.classify"
            @change="refresh"
          ></dic-selector>
        </el-form-item>
        <el-form-item class="mb-none">
          <el-input
            size="small"
            v-model="filterFrom.keyword"
            clearable
            placeholder="搜索示范辐射名称"
            style="width: 250px"
            @input="refresh"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>
        <div class="space"></div>
        <el-button
          v-if="power(userInfo.menuInfoList, 'demonstrationRadiation-export')"
          type="primary"
          class="el-icon-upload2"
          size="small"
          @click="toExport"
          >导出</el-button
        >
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="onPub"
          >发布示范辐射</el-button
        >
      </div>
      <el-form-item label="年级" class="filter-row mb-2px">
        <grade-selector
          controlType="checkbox"
          v-model="filterFrom.grades"
          @change="refresh"
        ></grade-selector>
      </el-form-item>
      <el-form-item label="学 科" class="filter-row mb-2px">
        <discipline
          controlType="checkbox"
          v-model="filterFrom.disciplineCodes"
          @change="refresh"
        ></discipline>
      </el-form-item>
    </el-form>
    <div class="list-box">
      <div class="column">
        <div>
          <el-menu
            :default-active="filterFrom.sortBy"
            active-text-color="#409EFF"
            mode="horizontal"
            @select="(index) => refresh('sortBy', index)"
          >
            <el-menu-item index="0">最热</el-menu-item>
            <el-menu-item index="1">最新</el-menu-item>
            <el-menu-item index="2">收藏</el-menu-item>
          </el-menu>
        </div>
        <div class="list-wrap">
          <div class="infinite-list-wrapper" v-loading="loading">
            <ul
              class="list"
              v-infinite-scroll="load"
              infinite-scroll-disabled="disabled"
            >
              <li
                v-for="(item, index) in list"
                :key="index"
                class="list-item"
                @click="
                  $router.push({
                    name: 'demonstrationRadiationDetail',
                    params: { id: item.id },
                  })
                "
              >
                <div class="article-icon"></div>
                <div class="article-main">
                  <div class="article-title">{{ item.title }}</div>
                  <div class="article-uv">
                    <span>
                      <i class="el-icon-view"></i>
                      {{ item.browseCount }}
                    </span>
                    <span>
                      <i class="el-icon-download"></i>
                      {{ item.downloadCount }}
                    </span>
                    <span>
                      <i class="el-icon-star-off"></i>
                      {{ item.collectCount }}
                    </span>
                  </div>
                </div>
                <div class="article-date">
                  上传者：{{ item.createName }}<br />
                  作者：{{ item.otherAuthor | otherAuthorFil }}<br />
                  {{ item.createTime }}发布
                </div>
              </li>
            </ul>
            <p class="no-more" v-if="noMore && !loading">没有更多了</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination.vue";
import dicSelector from "../../components/school/dicSelector.vue";
import Discipline from "../../components/school/disciplineSelector.vue";
import gradeSelector from "../../components/school/gradeSelector.vue";
import { mapGetters, mapState } from "vuex";
import { postData, postJson } from "../../http/fetch";
import { power, fileSaveZip } from "@/utils/index.js";
export default {
  name: "demonstrationRadiation",
  components: {
    dicSelector,
    Discipline,
    gradeSelector,
    Pagination,
  },
  data() {
    return {
      pageLoading: false,
      loading: false,
      noMore: false,
      filterFrom: {
        keyword: "",
        disciplineCodes: [],
        grades: [],
        sortBy: "0",
      },
      list: [],
      pageObj: {
        pageNum: 0,
        pageSize: 10,
      },
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    ...mapGetters(["schoolCodes", "operatorId"]),
    disabled() {
      return this.loading || this.noMore;
    },
  },
  methods: {
    power,
    toExport() {
      this.pageLoading = true;
      postJson("/teacherRadiationInfo/exportTeacherRadiationInfo", {
        pageNum: this.pageObj.pageNum,
        pageSize: this.pageObj.pageSize,
        sortBy: this.filterFrom.sortBy,
        keyword: this.filterFrom.keyword,
        operatorId: this.operatorId,
        schoolCodes: this.schoolCodes,
        classify: this.filterFrom.classify
          ? this.filterFrom.classify.dicCode
          : null,
        disciplineCodes: this.filterFrom.disciplineCodes.length
          ? this.filterFrom.disciplineCodes.map((m) => {
              return m.disciplineCode;
            })
          : null,
        grades: this.filterFrom.grades.length
          ? this.filterFrom.grades.map((m) => {
              return m.grade;
            })
          : null,
      })
        .then((data) => {
          fileSaveZip(data.url, data.name);
          this.pageLoading = false;
        })
        .catch(() => {
          this.pageLoading = false;
        });
    },
    onPub() {
      this.$router.push({
        name: "demonstrationRadiationAdd",
      });
    },
    load() {
      this.pageObj.pageNum += 1;
      Number.parseFloat("12.23"); //解决ie Number.parseFloat报错
      this.getData();
    },
    getData() {
      this.loading = true;
      postJson("/teacherRadiationInfo/getTeacherRadiationInfo", {
        pageNum: this.pageObj.pageNum,
        pageSize: this.pageObj.pageSize,
        sortBy: this.filterFrom.sortBy,
        keyword: this.filterFrom.keyword,
        operatorId: this.operatorId,
        schoolCodes: this.schoolCodes,
        classify: this.filterFrom.classify
          ? this.filterFrom.classify.dicCode
          : null,
        disciplineCodes: this.filterFrom.disciplineCodes.length
          ? this.filterFrom.disciplineCodes.map((m) => {
              return m.disciplineCode;
            })
          : null,
        grades: this.filterFrom.grades.length
          ? this.filterFrom.grades.map((m) => {
              return m.grade;
            })
          : null,
      })
        .then((res) => {
          if (res.records.length) {
            this.pageObj.pageNum == 1
              ? (this.list = res.records)
              : this.list.push(...res.records);
          } else {
            this.noMore = true;
          }
          if (this.pageObj.pageNum < res.pages) {
            this.noMore = false;
          } else {
            this.noMore = true;
          }
        })
        .catch((e) => {
          this.noMore = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    refresh(type, index) {
      if (type == "sortBy") {
        this.filterFrom.sortBy = index;
      }
      this.pageObj.pageNum = 1;
      this.list = [];
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.teaching-design {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.list-box {
  flex: 1;
  overflow: hidden;
}
.article-main {
  flex: 1;
}
</style>
